import { SearchDetailResult } from "interface/search"

export const hiddenFlags = (search: SearchDetailResult) => ({
	hideResult: search.status !== 8,
	hideDPC: search.disease?.some(d => d.dpcCode !== null && d.dpcCode !== '') !== true,
	hideCancer: search.disease?.some(d => d.cancerCode !== null && d.cancerCode !== '') !== true,
	hideJournal: (search.journalCount ?? 0) === 0,
	hideTrial: (search.trialCount ?? 0) === 0,
	hideResearch: (search.researchCount ?? 0) === 0,
	hideSenmoni: (search.senmoni?.length ?? 0) === 0,
	hideConvention: (search.convention?.length ?? 0) === 0,
	hideGuideLine: (search.guideLine?.length ?? 0) === 0
})
